var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3695_379)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 19.9091C17 18.3025 18.3025 17 19.9091 17H30.0909C31.6975 17 33 18.3025 33 19.9091V30.0909C33 31.6975 31.6975 33 30.0909 33H19.9091C18.3025 33 17 31.6975 17 30.0909V19.9091ZM19.9091 18.4545C19.1051 18.4545 18.4545 19.1051 18.4545 19.9091V30.0909C18.4545 30.8949 19.1051 31.5455 19.9091 31.5455H30.0909C30.8949 31.5455 31.5455 30.8949 31.5455 30.0909V19.9091C31.5455 19.1051 30.8949 18.4545 30.0909 18.4545H19.9091ZM20.8494 21.5767C21.1335 21.2926 21.5938 21.2926 21.8778 21.5767L24.7869 24.4858C25.071 24.7699 25.071 25.2301 24.7869 25.5142L21.8778 28.4233C21.5937 28.7074 21.1335 28.7074 20.8494 28.4233C20.5654 28.1392 20.5653 27.679 20.8494 27.3949L23.2443 25L20.8494 22.6052C20.5653 22.3211 20.5653 21.8608 20.8494 21.5767ZM25 27.1818C24.598 27.1818 24.2727 27.5071 24.2727 27.9091C24.2727 28.3111 24.598 28.6364 25 28.6364H28.6364C29.0384 28.6364 29.3636 28.3111 29.3636 27.9091C29.3636 27.5071 29.0384 27.1818 28.6364 27.1818H25Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3695_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav_icon_4.d1df6037d870b042923200b2414ad121.svg";
export { ForwardRef as ReactComponent };